/** Page sizes for GET `/jain_lexicon/terms/` — aligned with UI pagination controls. */

export const TERMS_PAGE_SIZE_OPTIONS = [25, 50, 100] as const;
export type TermsPageSizeOption = (typeof TERMS_PAGE_SIZE_OPTIONS)[number];

export const TERMS_PAGE_SIZES = {
  /** Browse + admin table default (matches PAGE_SIZE_OPTIONS[0]). */
  browseDefault: 25 as TermsPageSizeOption,
  /** Search results grid. */
  search: 30,
  /** SearchBar autocomplete dropdown. */
  autocomplete: 5,
  /** Home featured terms (client may still filter `featured`). */
  featured: 50,
  /** Related terms on term detail (+1 fetched, show 3). */
  related: 4,
  /** Admin activity log table. */
  activity: 10,
  /** `useTermsCount` / stats probe — only `count` is needed. */
  countProbe: 1,
  /** Chunk size when loading all pages (reports, contributions filter, my contributions). */
  fetchAllChunk: 100,
} as const;
